import { CreativeUnitListingDto } from "../../../../../../api/src/creative-unit-package/models/creative-unit/creative-unit-listing.dto";
import { ExportType } from "../../../../../../api/src/encode/models/job-def.dto";
import { CreativeUnitCategory } from "./ad-unit.model";
import { CreativeUnitDimensionsUnit } from '../../../../../../api/src/creative-unit-package/models/creative-unit/creative-unit.dto';


export const displayCreativeUnitSizes: CreativeUnitListingDto[] = [
	{
		id: 'facebook-banner-square',
		name: 'Facebook Feed Square',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 1080,
			height: 1080
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'facebook-banner-landscape',
		name: 'Facebook Feed Landscape',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 1200,
			height: 628
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'google-banner-landscape',
		name: 'Google Banner Landscape',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 600,
			height: 314
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'google-banner-square',
		name: 'Google Banner Square',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 300,
			height: 300
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'google-banner-large-skyscraper',
		name: 'Google Banner Large Skyscraper',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 300,
			height: 600
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'google-banner-medium-rectangle',
		name: 'Google Banner Medium Rectangle',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 300,
			height: 250
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'google-banner-large-rectangle',
		name: 'Google Banner Large Rectangle',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 336,
			height: 280
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'google-banner-leaderboard',
		name: 'Google Banner Leaderboard',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 728,
			height: 90
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'medium-banner',
		name: 'Medium Banner',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 300,
			height: 250
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'leaderboard',
		name: 'Leaderboard',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 728,
			height: 90
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'wide-skyscraper',
		name: 'Wide Skyscraper',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 160,
			height: 600
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'large-rectangle',
		name: 'Large Rectangle',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 336,
			height: 280
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'half-page',
		name: 'Half Page',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 300,
			height: 600
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'billboard',
		name: 'Billboard',
		metadata: {
			category: CreativeUnitCategory.DISPLAY_ANIMATED,
		},
		dimensions: {
			width: 970,
			height: 250
		},
		exportTypes: [ExportType.VIDEO]
	}
];

export const videoCreativeUnitSizes: CreativeUnitListingDto[] = [
	{
		id: 'hd-video',
		name: 'HD Video',
		dimensions: {
			width: 1920,
			height: 1080,
		},
		metadata: {
			category: CreativeUnitCategory.VIDEO,
		},
		exportTypes: [ExportType.VIDEO]
	}
];

export const customCreativeUnitSizes: CreativeUnitListingDto[] = [
	{
		id: 'custom-static',
		name: 'Create Your Own (Static)',
		description: 'Create a custom size for your creative unit',
		dimensions: {
			width: 500,
			height: 500
		},
		metadata: {
			category: CreativeUnitCategory.CUSTOM
		},
		exportTypes: [ExportType.STATIC]
	},
	{
		id: 'custom-motion',
		name: 'Create Your Own (Motion)',
		description: 'Create a custom size for your creative unit',
		dimensions: {
			width: 500,
			height: 500
		},
		animationConfig: {
			totalDuration: '15',
		},
		metadata: {
			category: CreativeUnitCategory.CUSTOM
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'figma-import',
		name: 'Import from Figma',
		description: 'Import designs directly from your Figma files',
		dimensions: {
			width: 500,
			height: 500
		},
		metadata: {
			category: CreativeUnitCategory.CUSTOM
		},
		exportTypes: [ExportType.STATIC]
	}
];

export const socialCreativeUnitSizes: CreativeUnitListingDto[] = [
	{
		id: 'social-post',
		name: 'Social Post',
		dimensions: {
			width: 1080,
			height: 1080,
		},
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'social-landscape',
		name: 'Social Landscape',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1200,
			height: 628,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'social-story',
		name: 'Social Story',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1080,
			height: 1920,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'social-vertical',
		name: 'Social Vertical',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1080,
			height: 1350,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'social-pin',
		name: 'Social Pin',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1200,
			height: 628,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'facebook-cover',
		name: 'Facebook Cover',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1200,
			height: 674,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'facebook-profile',
		name: 'Facebook Profile',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 400,
			height: 400,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'facebook-post',
		name: 'Facebook Post',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1200,
			height: 628,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'facebook-event-cover',
		name: 'Facebook Event Cover',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1920,
			height: 1005,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'linkedin-cover',
		name: 'LinkedIn Cover',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1584,
			height: 396,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'linkedin-profile',
		name: 'LinkedIn Profile',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 400,
			height: 400,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'linkedin-post',
		name: 'LinkedIn Post',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1200,
			height: 627,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'linkedin-article-cover',
		name: 'LinkedIn Article Cover',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1280,
			height: 720,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'instagram-profile',
		name: 'Instagram Profile',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 320,
			height: 320,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'instagram-story',
		name: 'Instagram Story',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1080,
			height: 1920,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'instagram-feed-landscape',
		name: 'Instagram Feed Landscape',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1080,
			height: 566,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'instagram-feed-portrait',
		name: 'Instagram Feed Portrait',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1080,
			height: 1350,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'instagram-feed-square',
		name: 'Instagram Feed Square',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1080,
			height: 1080,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'instagram-thumbnail',
		name: 'Instagram Thumbnail',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1080,
			height: 1080,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'twitter-profile',
		name: 'Twitter Profile',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 400,
			height: 400,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'twitter-header',
		name: 'Twitter Header',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1500,
			height: 500,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'twitter-stream',
		name: 'Twitter Stream',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1600,
			height: 900,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'twitter-card',
		name: 'Twitter Card',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1200,
			height: 628,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'youtube-profile',
		name: 'Youtube Profile',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 800,
			height: 800,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'youtube-banner',
		name: 'Youtube Banner',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 2056,
			height: 1440,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'youtube-thumbnail',
		name: 'Youtube Thumbnail',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 1280,
			height: 720,
		},
		exportTypes: [ExportType.VIDEO]
	},
	{
		id: 'tiktok-profile',
		name: 'TikTok Profile',
		metadata: {
			category: CreativeUnitCategory.SOCIAL_VIDEO,
		},
		dimensions: {
			width: 200,
			height: 200,
		},
		exportTypes: [ExportType.VIDEO]
	}
];

/**
 * Default Creative Unit Sizes
 * These are used for editors to quickly build out proper sizes based on popular formats.
 */
export const creativeUnitSizes: CreativeUnitListingDto[] = [
	// {
	// 	id: 'design-set',
	// 	name: 'Design Set Test',
	// 	dimensions: {
	// 		width: 1080,
	// 		height: 1080,
	// 	},
	// 	metadata: {
	// 		category: CreativeUnitCategory.CUSTOM,
	// 	},
	// 	children: [
	// 		{
	// 			id: 'social-landscape',
	// 			name: 'Social Landscape',
	// 			metadata: {
	// 				category: CreativeUnitCategory.SOCIAL_VIDEO,
	// 			},
	// 			dimensions: {
	// 				width: 1200,
	// 				height: 628,
	// 			},
	// 			exportTypes: [ExportType.VIDEO]
	// 		},
	// 		{
	// 			id: 'hd-video',
	// 			name: 'HD Video',
	// 			dimensions: {
	// 				width: 1920,
	// 				height: 1080,
	// 			},
	// 			metadata: {
	// 				category: CreativeUnitCategory.VIDEO,
	// 			},
	// 			exportTypes: [ExportType.VIDEO]
	// 		}
	// 	],
	// 	exportTypes: [ExportType.VIDEO]
	// },
	...displayCreativeUnitSizes.map(s => ({
		...s,
		id: s.id + '-animated',
		animationConfig: {
			totalDuration: '6',
		}
	})),
	...displayCreativeUnitSizes.map(s => ({
		...s,
		id: s.id + '-static',
		metadata: {...s.metadata, category: CreativeUnitCategory.DISPLAY_STATIC},
		exportTypes: [ExportType.STATIC]
	})),
	...videoCreativeUnitSizes.map(s => ({
		...s,
		id: s.id + '-animated',
		animationConfig: {
			totalDuration: '30',
		}
	})),
	...socialCreativeUnitSizes.map(s => ({
		...s,
		id: s.id + '-animated',
		animationConfig: {
			totalDuration: '15',
		}
	})),
	...socialCreativeUnitSizes.map(s => ({
		...s,
		id: s.id + '-static',
		metadata: {...s.metadata, category: CreativeUnitCategory.SOCIAL_STATIC},
		exportTypes: [ExportType.STATIC]
	})),
	...customCreativeUnitSizes
];


export const shapeGallery = [
	{
		name: 'Rectangle',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMinYMin meet">
				<rect x="0" y="0" width="100%" height="100%" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Circle',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<circle cx="50" cy="50" r="45" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Triangle',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="50,10 90,90 10,90" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Diamond',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="50,10 90,50 50,90 10,50" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Star',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="250,0 305,175 490,175 350,300 405,475 250,370 95,475 150,300 10,175 195,175" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Heart',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<path d="m 250,465 c -350,-233 -233,-584 0,-350 233,-233 350,116 0,350 z" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Pentagon',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="50,8 92,39.9 79.1,92 20.9,92 8,39.9" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Hexagon',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Octagon',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="28.5,5 71.5,5 95,28.5 95,71.5 71.5,95 28.5,95 5,71.5 5,28.5" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'Arrow',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<polygon points="10,50 50,10 50,35 90,35 90,65 50,65 50,90" fill="currentColor" />
			</svg>
		`
	},
	{
		name: 'X',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
			  <polygon points="20,10 10,20 50,60 10,100 20,110 60,70 100,110 110,100 70,60 110,20 100,10 60,50" fill="currentColor"/>
			</svg>
		`
	},
	{
		name: 'Checkmark',
		code: `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
				<path d="M10,50 L40,80 L90,20 L80,10 L40,60 L20,40 Z" fill="currentColor"/>
			</svg>
		`
	}
];

export const DisplayUnitListValues = () => [
	{
		value: CreativeUnitDimensionsUnit.PIXELS,
		label: $localize `:List Item@@adCreativeUnitDimensionsUnitPixelsLabel:Pixels`
	},
	{
		value: CreativeUnitDimensionsUnit.INCHES,
		label: $localize `:List Item@@adCreativeUnitDimensionsUnitInchesLabel:Inches`
	},
	{
		value: CreativeUnitDimensionsUnit.MILLIMETERS,
		label: $localize `:List Item@@adCreativeUnitDimensionsUnitMillimetersLabel:Millimeters`
	},
	{
		value: CreativeUnitDimensionsUnit.CENTIMETERS,
		label: $localize `:List Item@@adCreativeUnitDimensionsUnitCentimetersLabel:Centimeters`
	},
	{
		value: CreativeUnitDimensionsUnit.PICAS,
		label: $localize `:List Item@@adCreativeUnitDimensionsUnitPicasLabel:Picas`
	},
	{
		value: CreativeUnitDimensionsUnit.POINTS,
		label: $localize `:List Item@@adCreativeUnitDimensionsUnitPointsLabel:Points`
	}
];
